<template>

<app-input-wrapper class="check" :value="value" :errored="errored" :class="{'is-active': value === checkValue}">

	<app-text class="input-label">

		<p :class="{'is-bold': text}" v-html="labelText"></p>

		<p>{{ text }}</p>

	</app-text>

	<div class="input-check" v-on:click="onCheckClick">

		<app-icon name="tick" />

	</div>

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

	mixins: [mixinInput],

	props: ['text', 'override'],

	computed: {

		labelText: function() {

			var labelText = this.label

			labelText = labelText.replace('<p>', '').replace('</p>', '')

			return labelText

		},

		checkValue: function() {

			return (this.override) ? parseInt(this.override) : 1

		}

	},

	methods: {

		onCheckClick: function() {

			this.$emit('input', (this.value === this.checkValue) ? 0 : this.checkValue)

		}

	}

}

</script>

<style scoped>

.input-label {
	font-size: 14px;
	line-height: 20px;
	color: var(--color-grey-dark);
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex-grow: 1;
	min-height: 40px;
}

.is-tablet .check >>> .input-content-input,
.is-mobile .check >>> .input-content-input {
    flex-direction: row!important;
}

.input-label p {
	margin-bottom: 0px!important;
    font-weight: 300!important;
}

.input-label p.is-bold {
	font-weight: 700!important;
}

.input-check {
	border: 1px solid var(--color-grey-light);
	border-radius: 4px;
	width: 40px;
	height: 40px;
	cursor: pointer;
	font-size: 16px;
	text-align: center;
	line-height: 40px;
	color: var(--color-grey-light);
	transition: all 100ms linear;
	flex-shrink: 0;
	margin-left: 20px;
}

.is-desktop .input-check:hover {
	color: var(--color-grey-highlight);
	border: 1px solid var(--color-grey-highlight);
}

.input.is-active .input-check {
	color: #fff;
	background-color: var(--color-blue-light);
	border: 1px solid var(--color-blue-light);
}

.is-desktop .input.is-active .input-check:hover {
	background-color: var(--color-blue-dark);
	border: 1px solid var(--color-blue-dark);
}

</style>